import { ComboNgSelect, ComboPickListViewData } from './combos';
import { Dictionary } from './dictionary';
import { HistoricoAccesoFichero } from './file';
import { Serie } from './serie';
import { TipoEstado, TipoEstadoFactory } from './tipo-estado-solicitud';
import { UbicacionUnidadDocumental } from './ubicacion-unidad-documental';

export enum SearchOperators {
  OR = 'OR',
  AND = 'AND'
}

export enum TypeShoppingCart {
  INSERTION = 'INSERTION',
  LOAN = 'LOAN',
  PARTIAL_LOAN = 'PARTIAL_LOAN'
}

export enum TIPO_DOCUMENTAL {
  expediente = 0,
  az = 1,
  contenedor = 2
}

export enum ESTADO_CONTENEDOR {
  nuevo = 1,
  ubicado = 2,
  prestado = 4,
  expurgado = 5
}

export enum SIGNO_FECHA {
  greather = '>',
  less = '<',
  equal = '='
}

export class ResponseCargaInventario {

  constructor(
    public isOk: boolean = false,
    public errores: PlantillaValidationErrors[] = [],
    public errorGenerico: string = '',
    public numeroRegistros: number = 0,
    public pendienteAuth: boolean = false
  ) { }
}

export class PlantillaValidationErrors {

  constructor(
    public Field: string = '',
    public ErrorMessage: string = '',
    public Address: string = ''
  ) { }
}

export class ElasticExpedientesByKeyword {

  constructor(
    public PALABRAS_CLAVE: string[],
    public OPERADOR: SearchOperators,
    public onlyPrestadas: boolean,
    // SRR 🥑🥑 Busqueda de inventario con referencia externa
    public idGrupo: string = '') { }
}

export class ExportExpedientes {
  public AdvancedSearchFilter: ExpedienteFiltroDTO;
  public KeywordSearchFilter: ElasticExpedientesByKeyword;
}

export class Valores extends Dictionary {
  constructor(init: { key: string; value: any; }[]) {
    super(init);
  }
}

export class ValoresView {
  rows: any[];
  constructor() { }
}

export class Estados {
  activo?: string;
  bloqueado?: string;
  expurgo_logico?: string;
  expurgo_fisico?: string;
  pendiente_recepcion?: string;
  baja?: string;
  prestado?: string;
  transporte?: string;

  constructor() { }

  static toModel(json: string): Estados {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new Estados();
    toReturn.activo = data.ACTIVO || data.aCTIVO;
    toReturn.bloqueado = data.BLOQUEADO || data.bLOQUEADO;
    toReturn.expurgo_logico = data.EXPURGO_LOGICO || data.eXPURGO_LOGICO;
    toReturn.expurgo_fisico = data.EXPURGO_FISICO || data.eXPURGO_FISICO;
    toReturn.pendiente_recepcion = data.PENDIENTE_RECEPCION || data.pENDIENTE_RECEPCION;

    toReturn.baja = data.BAJA || data.bAJA;
    toReturn.prestado = data.PRESTADO || data.pRESTADO;
    toReturn.transporte = data.TRANSPORTE || data.tRANSPORTE;

    return toReturn;
  }
}

export class Bloqueos {
  usuarioBloqueoId?: number;
  infoBloqueo?: string;
  fechaInicioBloqueo?: string;
  fechaFinBloqueo?: string;
  usuarioDesbloqueoId?: number;

  constructor() { }

  static toModel(json: string): Bloqueos {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new Bloqueos();
    toReturn.usuarioBloqueoId = data.ID_USUARIO_BLOQUEO;
    toReturn.infoBloqueo = data.INFO_BLOQUEO;
    toReturn.fechaInicioBloqueo = data.FECHA_INICIO_BLOQUEO;
    toReturn.fechaFinBloqueo = data.FECHA_FIN_BLOQUEO;
    toReturn.usuarioDesbloqueoId = data.ID_USUARIO_DESBLOQUEO;

    return toReturn;
  }
}

export class FullTextHojas {
  numeroHoja: number;
  fullText: string;

  constructor() { }

  static toModel(json: string): FullTextHojas {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new FullTextHojas();
    toReturn.numeroHoja = data.NUMERO_HOJA;
    toReturn.fullText = data.FULL_TEXT;

    return toReturn;
  }
}

export class Imagen {
  GUID: string;
  mimetype: string;
  version: number;
  GUID_miniaturas: string;
  numeroHojas?: number;
  size?: number;
  secLevelId?: number;
  hojasFullText?: FullTextHojas[];
  imageSrc?: ArrayBuffer;
  imageMiniaturaSrc?: ArrayBuffer;

  constructor() { }

  static toModel(json: string): Imagen {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new Imagen();
    toReturn.GUID = data.GUID;
    toReturn.mimetype = data.MIMETYPE;
    toReturn.version = data.VERSION;
    toReturn.GUID_miniaturas = data.GUID_MINIATURAS;
    toReturn.numeroHojas = data.NUMERO_HOJAS;
    toReturn.size = data.SIZE;
    toReturn.secLevelId = data.ID_SEC_LEVEL;
    toReturn.hojasFullText = data.HOJAS_FULLTEXT ? data.HOJAS_FULLTEXT.map(fullTextHoja => FullTextHojas.toModel(JSON.stringify(fullTextHoja)))
      : null;

    return toReturn;
  }
}
export class Parciales {
  parcialId: number;
  description: string;
  usuarioInsercionId: number;
  prestamoParcialId: string;
  imagenAsociada?: Imagen;
  fechaCreacion?: string;
  estado?: Estados;
  imageSecurityLevelState: string;

  constructor() { }

  static toModel(json: string): Parciales {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new Parciales();
    toReturn.parcialId = data.ID_PARCIAL;
    toReturn.description = data.DESCRIPCION;
    toReturn.imagenAsociada = Imagen.toModel(JSON.stringify(data.IMAGEN_ASOCIADA));
    toReturn.usuarioInsercionId = data.ID_USUARIO_INSERCCION;
    toReturn.prestamoParcialId = data.ID_PRESTAMO_PARCIAL;
    toReturn.fechaCreacion = data.FECHA_CREACION;
    toReturn.estado = Estados.toModel(JSON.stringify(data.ESTADO));
    toReturn.imageSecurityLevelState = 'out';

    return toReturn;
  }
}

export class HistorialSolicitudes {
  solicitudId: number;
  fechaSolicitud: string;
  fechaFinalizacion: string;
  usuarioId: number;
  usuarioSolicitante: string;
  tipoSolicitud: string;
  estadoSolicitud: string;
  situacionSolicitud: string;
  tipoEstado: TipoEstado;

  constructor() { }

  static toModel(json: string): HistorialSolicitudes {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new HistorialSolicitudes();
    toReturn.solicitudId = data.ID_SOLICITUD;
    toReturn.fechaSolicitud = data.FECHA_SOLICITUD;
    toReturn.fechaFinalizacion = data.FECHA_FINALIZACION;
    toReturn.usuarioId = data.ID_USUARIO;
    toReturn.tipoSolicitud = data.TIPO_SOLICITUD;
    toReturn.usuarioSolicitante = data.USUARIO_SOLICITANTE;
    toReturn.estadoSolicitud = data.ESTADO_SOLICITUD;
    toReturn.situacionSolicitud = data.SITUACION_SOLICITUD;
    toReturn.tipoEstado = TipoEstadoFactory.getTipoEstado(data.TIPO_ESTADO);

    return toReturn;
  }
}

export class HistorialCambios {
  usuarioId: number;
  nombreUsuario: string;
  campoCambio: string;
  fechaCambio: Date;
  valorAnterior: string;
  valorPosterior: string;

  constructor() { }

  static toModel(json: string): HistorialCambios {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new HistorialCambios();
    toReturn.usuarioId = data.ID_USUARIO;
    toReturn.campoCambio = data.CAMPO_CAMBIO;
    if (data.FECHA_CAMBIO) {
      toReturn.fechaCambio = new Date(data.FECHA_CAMBIO);
    }
    toReturn.valorAnterior = data.VALOR_ANTERIOR;
    toReturn.valorPosterior = data.VALOR_POSTERIOR;

    return toReturn;
  }
}

export class GruposAcceso {
  grupoId: number;
  fechaConcesion: string;

  constructor() { }

  static toModel(json: string): GruposAcceso {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new GruposAcceso();
    toReturn.grupoId = data.ID_GRUPO;
    toReturn.fechaConcesion = data.FECHA_CONCESION;

    return toReturn;
  }
}

export interface StateViewer {
  name: string;
  iconClass: string;
  color: string;
  title: string;
}

export interface InventoryIdenty {
  id: string | number;
  shoppingCart: ShoppingCart;
  tipoDocumental: TIPO_DOCUMENTAL;
}

export interface IElasticReturnClass {
  id: string | number;
  clienteId: number;
}

export class IResultadoDocument<T> implements InventoryIdenty {
  id: string;
  indexName: string;
  version?: number;
  score?: number;
  sorts: any;
  shoppingCart: ShoppingCart;
  document: T;
  tipoDocumental: TIPO_DOCUMENTAL;

  static toModel<T extends IElasticReturnClass>(json: string, viewClass: IElasticReturnClassBuilder<T>): IResultadoDocument<IElasticReturnClass> {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new IResultadoDocument<IElasticReturnClass>();
    toReturn.id = data.Id;
    toReturn.indexName = data.IndexName;
    toReturn.version = data.Version;
    toReturn.score = data.Score;
    toReturn.sorts = data.Sorts;
    toReturn.document = viewClass.toModel(JSON.stringify(data.Document));
    toReturn.tipoDocumental = TIPO_DOCUMENTAL.expediente;
    return toReturn;
  }
}

export class IResultadoSearch<T> {
  took: number;
  isValid: boolean;
  maxScore: number;
  total: number;
  debugInformation: string;
  endPoint: string;
  documents: IResultadoDocument<T>[];

  static toModel<T extends IElasticReturnClass>(json: string, viewClass: IElasticReturnClassBuilder<T>): IResultadoSearch<T> {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new IResultadoSearch<T>();
    toReturn.took = data.took;
    toReturn.isValid = data.isValid;
    toReturn.maxScore = data.MaxScore;
    toReturn.total = data.Total;
    toReturn.debugInformation = data.DebugInformation;
    toReturn.endPoint = data.EndPoint;
    toReturn.documents = data.Documents.map(document => IResultadoDocument.toModel<T>(JSON.stringify(document), viewClass));

    return toReturn;
  }
}
export class ShoppingCart {
  obsPartial?: string;
  type?: TypeShoppingCart;

  constructor() { }
}

export class ValuesWithFullTextHighlight {
  constructor(public fullTextHighlights: FullTextSummaryHighlight[], public isMultivalue: boolean) { }
}

export class FullTextSummaryHighlight {
  text: string;
  highlight: boolean;
  order: number;
  constructor(text: string, highlight: boolean) {
    this.text = text;
    this.highlight = highlight;
  }
}

export class FullTextSummary {
  textBefore: string;
  textHighlightSearch: string;
  textAfter: string;

  constructor() { }
}

export class UnidadDocumentalSimple {
  id: string | number;
  fechaCreacion: string;
  estado: Estados | ESTADO_CONTENEDOR;
  tipoDocumental: TIPO_DOCUMENTAL;
  estadosViewer?: StateViewer[];
  fieldsToShow?: { key: string; value: any; }[];

  constructor() { }
}


export class Expedientes extends UnidadDocumentalSimple implements IElasticReturnClass {
  id: string;
  clienteId: number;
  description: string;
  contenedorId?: number;
  contenedorNumber?: number;
  azId?: number;
  serieId?: number;
  nombreSerie?: string;
  grupoOrigenDescripcion?: string;
  usuarioCreacionId?: number;
  secLevelId?: number;
  fechaExpurgo?: string;

  bloqueos?: Bloqueos[];
  imagenAsociada?: Imagen;
  parciales?: Parciales[];
  historialSolicitudes?: HistorialSolicitudes[];
  historicoAccesoFichero?: HistoricoAccesoFichero[];
  ubicacionExpediente?: UbicacionUnidadDocumental;
  historialCambios?: HistorialCambios[];
  gruposAcceso?: GruposAcceso[];
  hasFullTextCoincidence?: boolean;
  valores?: Valores;
  fullTextSummary?: FullTextSummary;
  fieldsToShow?: { key: string; value: any; }[];

  constructor() { super(); }


  // TODO: revisar si es posible que las variables solo se encuentren con un nombre
  static toModel(json: string): Expedientes {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new Expedientes();
    toReturn.id = data.id || data.Id;
    toReturn.clienteId = data.iD_CLIENTE || data.ID_CLIENTE;
    toReturn.description = data.dESCRIPCION || data.DESCRIPCION;
    toReturn.contenedorId = data.iD_CONTENEDOR || data.ID_CONTENEDOR;
    toReturn.contenedorNumber = data.nUM_CONTENEDOR || data.NUM_CONTENEDOR;
    toReturn.azId = data.iD_AZ || data.ID_AZ;

    toReturn.serieId = data.iD_SERIE || data.ID_SERIE;
    toReturn.nombreSerie = data.NOMBRE_SERIE;

    toReturn.grupoOrigenDescripcion = data.GRUPO_ORIGEN_DESCRIPCION;

    toReturn.usuarioCreacionId = data.iD_USUARIO_CREACION || data.ID_USUARIO_CREACION;
    toReturn.secLevelId = data.iD_SEC_LEVEL || data.ID_SEC_LEVEL;
    toReturn.fechaCreacion = data.fECHA_CREACION || data.FECHA_CREACION;
    toReturn.fechaExpurgo = data.fECHA_EXPURGO || data.FECHA_EXPURGO;

    toReturn.hasFullTextCoincidence = data.HasFullTextCoincidence || data.hasFullTextCoincidence;

    const estado = data.eSTADO || data.ESTADO;
    if (estado) {
      toReturn.estado = Estados.toModel(JSON.stringify(estado));
    }
    const bloqueos = data.BLOQUEOS || data.bLOQUEOS;
    if (bloqueos) {
      toReturn.bloqueos = [].concat(bloqueos).map(bloqueo => Bloqueos.toModel(JSON.stringify(bloqueo)));
    }

    const imagen = data.iMAGEN_ASOCIADA || data.IMAGEN_ASOCIADA;
    if (imagen) {
      toReturn.imagenAsociada = Imagen.toModel(JSON.stringify(imagen));
    }

    const parciales = data.pARCIALES || data.PARCIALES;
    if (parciales) {
      toReturn.parciales = [].concat(parciales).map(parcial => Parciales.toModel(JSON.stringify(parcial)));
    }

    const historialSolicitudes = data.hISTORIAL_SOLICITUDES || data.HISTORIAL_SOLICITUDES;
    if (historialSolicitudes) {
      toReturn.historialSolicitudes = [].concat(historialSolicitudes)
        .map(historialSolicitud => HistorialSolicitudes.toModel(JSON.stringify(historialSolicitud)));
    }

    const historialCambios = data.hISTORIAL_CAMBIOS || data.HISTORIAL_CAMBIOS;
    if (historialCambios) {
      toReturn.historialCambios = [].concat(historialCambios).map(historialCambio => HistorialCambios.toModel(JSON.stringify(historialCambio)));
    }

    const gruposAcceso = data.gRUPOS_ACCESO || data.GRUPOS_ACCESO;
    if (gruposAcceso) {
      toReturn.gruposAcceso = [].concat(gruposAcceso).map(grupoAcceso => GruposAcceso.toModel(JSON.stringify(grupoAcceso)));
    }

    const valores = data.Valores || data.valores;
    if (valores) {
      toReturn.valores = new Valores(valores);
    }

    toReturn.tipoDocumental = TIPO_DOCUMENTAL.expediente;
    return toReturn;
  }
}




export class Contenedores extends UnidadDocumentalSimple implements IElasticReturnClass, InventoryIdenty {
  id: number;
  clienteId: number;
  albaranId?: number;
  numContenedor?: number;

  fechaEntrada?: string;
  fechaCreacion: string;
  fechaExpurgo?: string;
  fechaEstado?: string;
  shoppingCart: ShoppingCart;
  tipoDocumental: TIPO_DOCUMENTAL;
  serieId: number;

  estado: ESTADO_CONTENEDOR;
  canMakeOperations?: boolean;
  estadosViewer?: StateViewer[];


  constructor() { super(); }


  static toModel(json: string): Contenedores {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new Contenedores();
    toReturn.id = data.Id;

    toReturn.albaranId = data.ID_ALBARAN;
    toReturn.numContenedor = data.NUM_CONTENEDOR;
    toReturn.clienteId = data.ID_CLIENTE;

    toReturn.fechaEntrada = data.FECHA_ENTRADA;
    toReturn.fechaCreacion = data.FECHA_CREACION;
    toReturn.fechaEstado = data.FECHA_ESTADO;
    toReturn.fechaExpurgo = data.FECHA_EXPURGO;
    toReturn.estado = <any>ESTADO_CONTENEDOR[data.ESTADO] as ESTADO_CONTENEDOR;
    toReturn.tipoDocumental = TIPO_DOCUMENTAL.contenedor;
    toReturn.serieId = data.ID_SERIE;
    toReturn.canMakeOperations = data.CAN_MAKE_OPERATIONS;

    return toReturn;
  }
}

export class ContenedorDetail implements IElasticReturnClass, InventoryIdenty {
  id: number;
  albaranId?: number;
  numContenedor?: number;

  fechaEntrada?: string;
  fechaCreacion?: string;
  fechaExpurgo?: string;
  fechaEstado?: string;

  descripcion?: string;

  estado?: ESTADO_CONTENEDOR;
  departamentoId: number;
  seriesId: number[];
  signaturaId: number;
  activoTipoContenedor: string;
  descripcionTipoContenedor: string;

  shoppingCart: ShoppingCart;
  tipoDocumental: TIPO_DOCUMENTAL;

  clienteId: number;
  clientName: string;


  ubicacionContenedor: UbicacionUnidadDocumental;
  serie: Serie;

  departamentos: ComboPickListViewData[];

  canMakeOperations: boolean;

  unidadesDocumentales: UnidadDocumental;

  constructor() {
  }


  static toModel(json: string): ContenedorDetail {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new ContenedorDetail();
    toReturn.id = data.Id;

    toReturn.albaranId = data.ID_ALBARAN;
    toReturn.activoTipoContenedor = data.ACTIVO_TIPO_CONTENEDOR;
    toReturn.descripcionTipoContenedor = data.DESCRIPCION_TIPO_CONTENEDOR;
    toReturn.numContenedor = data.NUM_CONTENEDOR;
    toReturn.descripcion = data.DESCRIPCION;

    toReturn.fechaEntrada = data.FECHA_ENTRADA;
    toReturn.fechaCreacion = data.FECHA_CREACION;
    toReturn.fechaExpurgo = data.FECHA_EXPURGO;
    toReturn.fechaEstado = data.FECHA_ESTADO;

    toReturn.estado = <any>ESTADO_CONTENEDOR[data.ESTADO] as ESTADO_CONTENEDOR;
    toReturn.departamentoId = data.ID_DEPARTAMENTO;
    toReturn.seriesId = data.ID_SERIE_R2;
    toReturn.signaturaId = data.ID_SIGNATURA;
    toReturn.tipoDocumental = TIPO_DOCUMENTAL.contenedor;
    toReturn.clienteId = data.ID_CLIENTE;
    toReturn.clientName = data.NOMBRE_CLIENTE;
    toReturn.departamentos = this.convertToComboPickListViewData(data.DEPARTAMENTOS);
    toReturn.canMakeOperations = data.CAN_MAKE_OPERATIONS;

    return toReturn;
  }
  private static convertToComboPickListViewData(departamentosSeries: any): ComboPickListViewData[] {
    const combo: ComboPickListViewData[] = [];
    departamentosSeries.forEach(element => {
      const newCombo = new ComboPickListViewData();
      newCombo.ID = element.Id;
      newCombo.NOMBRE = element.NOMBRE;
      newCombo.elements = element.Series.map(serie => {
        const comboNgSelect = new ComboNgSelect();
        comboNgSelect.ID = serie.Id;
        comboNgSelect.NOMBRE = serie.NOMBRE;
        return comboNgSelect;
      });
      combo.push(newCombo);
    });

    return combo;
  }
}
interface IElasticReturnClassBuilder<T extends IElasticReturnClass> {
  new(): T;
  toModel(json: string): T;
}
export class FechaContenedor {
  fecha: Date;
  signo: string;

  constructor() {
    this.signo = SIGNO_FECHA.greather;
  }
}

export class ContenedorFiltroDTO {
  Id?: number;
  ID_CLIENTE?: number;
  ID_SERIE?: number;
  NUM_CONTENEDOR?: number;
  ESTADO?: number;
  // 1 por id, 2 por fecha_creacion, 3 por fecha_entrada, 4 por fecha_estado, 5 por cliente, 6 por serie
  ORDENACION?: number;
  ASC?: boolean;

  FECHA_ENTRADA?: Date;
  FECHA_CREACION?: Date;
  FECHA_ESTADO?: Date;

  sFECHA_CREACION?: string;
  sFECHA_ENTRADA?: string;
  sFECHA_ESTADO?: string;
}

export class FiltroAZ {
  idContenedor: number;
  filtroDescripcion: string;
  idSerie: number;
}


export class ContenedorFiltroView {
  Id?: number;
  ID_CLIENTE?: number;
  ID_SERIE?: number;
  NUM_CONTENEDOR?: number;
  FECHA_ENTRADA?: FechaContenedor;
  FECHA_CREACION?: FechaContenedor;
  FECHA_ESTADO?: FechaContenedor;
  ESTADO?: number;

  // 1 por id, 2 por fecha_creacion, 3 por fecha_entrada, 4 por fecha_estado, 5 por cliente, 6 por serie
  ORDENACION?: number;
  ASC?: boolean;

  constructor() {
    this.FECHA_ENTRADA = new FechaContenedor();
    this.FECHA_CREACION = new FechaContenedor();
    this.FECHA_ESTADO = new FechaContenedor();
  }
}

export class FiltrosFechas {
  ValorMenor: string;
  ValorMayor: string;
  Field: string;

  constructor() { }
}


export class ExpedienteFiltroDTO {
  ID_CLIENTE?: number;
  ID_SEC_LEVEL?: number;
  ID_SERIE?: number;
  FiltrosSobreFechas?: FiltrosFechas[];
  ESTADO_ACTIVO?: boolean;
  ESTADO_BLOQUEAO?: boolean;
  ESTADO_EXPURGO_LOGICO?: boolean;

  ESTADO_EXPURGO_FISICO?: boolean;
  ESTADO_BAJA?: boolean;
  ESTADO_PRESTADO?: boolean;
  ESTADO_TRANSPORTE?: boolean;
  VALORES?: any;
}

export class DetalleExpediente {
  constructor(
    public expediente: IResultadoDocument<Expedientes>,
    public keywords: ElasticExpedientesByKeyword,
    public expedientes: IResultadoDocument<Expedientes>[]
  ) { }
}

export class ResponseAddRelacionContenidoUnidadDocumental {
  constructor(
    public isOk: boolean,
    public erroresDetectados: string[]
  ) { }
}

export class AZ extends UnidadDocumentalSimple implements InventoryIdenty {
  id: string;
  descripcion: string;
  contenedorId: number;
  contenedorNumber?: number;
  levelSecId: number;
  bloqueos: Bloqueos[];
  historialCambios?: HistorialCambios[];
  shoppingCart: ShoppingCart;

  constructor() {
    super();
  }


  static toModel(json: string): AZ {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new AZ();
    toReturn.id = data.id || data.iD;
    toReturn.fechaCreacion = data.fECHA_CREACION;
    toReturn.descripcion = data.dESCRIPCION_AZ;
    toReturn.contenedorId = data.iD_CONTENEDOR;
    toReturn.contenedorNumber = data.nUM_CONTENEDOR || data.NUM_CONTENEDOR;
    toReturn.levelSecId = data.iD_SEC_LEVEL;
    toReturn.estado = Estados.toModel(JSON.stringify(data.eSTADO));
    toReturn.bloqueos = data.bLOQUEOS ? data.bLOQUEOS.map(bloqueo => Bloqueos.toModel(JSON.stringify(bloqueo))) : undefined;
    toReturn.historialCambios = data.hISTORIAL_CAMBIOS
      ? data.hISTORIAL_CAMBIOS.map(historialCambio => HistorialCambios.toModel(JSON.stringify(historialCambio)))
      : undefined;

    toReturn.tipoDocumental = TIPO_DOCUMENTAL.az;
    return toReturn;
  }
}

export class UnidadDocumental {
  totalUnidades: number;
  expedientes: Expedientes[];
  azs: AZ[];

  constructor() { }


  static toModel(json: string): UnidadDocumental {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new UnidadDocumental();
    toReturn.totalUnidades = data.CONTADOR_TOTAL;
    // toReturn.expedientes = data.EXPEDIENTES.map(expediente => Expedientes.toModel(JSON.stringify(expediente)));
    toReturn.expedientes = data.DOCUMENTOS.filter(doc => doc.Index === 'expedientes').map(doc => Expedientes.toModel(JSON.stringify(doc.Source)));
    // toReturn.azs = data.AZ.map(az => AZ.toModel(JSON.stringify(az)));
    toReturn.azs = data.DOCUMENTOS.filter(doc => doc.Index === 'az').map(doc => AZ.toModel(JSON.stringify(doc.Source)));
    return toReturn;
  }
}

export class GrupoOficina {

  constructor(
    public ID_GRUPO: string,
    public DESCRIPCION: string,
    public REFERENCIA_EXTERNA: string
  ) { }
}

